/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Error_Name_RequiredInputs */

const en_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share name cannot be empty.`)
};

const fr_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom du partage ne peut pas être vide.`)
};

const de_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Freigabename darf nicht leer sein.`)
};

const it_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nome della condivisione non può essere vuoto.`)
};

const ru_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя общего ресурса не может быть пустым.`)
};

const es_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre compartido no puede estar vacío.`)
};

const zh_cn2_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`股票名称不能为空。`)
};

const ja_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有名は空にできません。`)
};

const hi_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर का नाम खाली नहीं हो सकता।`)
};

const pt_pt2_team_share_error_name_required = /** @type {(inputs: Team_Share_Error_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome da ação não pode estar vazio.`)
};

/**
* | output |
* | --- |
* | "Share name cannot be empty." |
*
* @param {Team_Share_Error_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_error_name_required = /** @type {((inputs?: Team_Share_Error_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Error_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_error_name_required(inputs)
	if (locale === "de") return de_team_share_error_name_required(inputs)
	if (locale === "it") return it_team_share_error_name_required(inputs)
	if (locale === "ru") return ru_team_share_error_name_required(inputs)
	if (locale === "es") return es_team_share_error_name_required(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_error_name_required(inputs)
	if (locale === "ja") return ja_team_share_error_name_required(inputs)
	if (locale === "hi") return hi_team_share_error_name_required(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_error_name_required(inputs)
	return en_team_share_error_name_required(inputs)
});